import { defineAbility } from '@casl/ability';
import { getItemFromStore } from 'helpers/utils';

const permissionActionMap = {
  View: 'view',
  Maker: 'maker',
  Edit: 'edit',
  Delete: 'delete',
  Checker: 'checker',
  Approver: 'approver',
  Payer: 'payer'
};

export function defineAbilityFor(role, permissions) {
  console.log('🚀 ~ defineAbilityFor ~ permissions:', permissions);
  let ability;
  const isInMobileApp = getItemFromStore('loginInMobileApp', false);

  // Handle case when no permissions are provided
  if (!permissions) {
    return defineAbility(can => {
      can('view', 'Test');
    });
  }

  ability = defineAbility(can => {
    can('view', 'All');
    if (role === 'Admin') {
      can('view', 'Role Permission');
    }
    if (!isInMobileApp) {
      can('view', 'My Dashboard');
    }

    // Process new permissions format (object)
    Object.entries(permissions).forEach(([moduleName, actions]) => {
      // Skip mobile app restriction for my_dashboard module
      if (isInMobileApp && moduleName.toLowerCase() === 'my dashboard') {
        console.log('Not authorized for my_dashboard in mobile app');
        return;
      }

      // Process each action permission for the module
      Object.entries(actions).forEach(([actionName, isAllowed]) => {
        if (isAllowed) {
          const caslAction =
            permissionActionMap[actionName] || actionName.toLowerCase();
          can(caslAction, moduleName);
        }
      });
    });
  });

  return ability;
}
